import { lazy } from 'react';
const labdrilldown = lazy(() => import('./labdrilldown'));

const labdrilldownRoutes = [
  {
    path: '/labdrilldown',
    component: labdrilldown
  }
];

export default labdrilldownRoutes;
